import { render } from "./8ImageGallery.vue?vue&type=template&id=7c124906&scoped=true"
import script from "./8ImageGallery.vue?vue&type=script&lang=js"
export * from "./8ImageGallery.vue?vue&type=script&lang=js"

import "./8ImageGallery.vue?vue&type=style&index=0&id=7c124906&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c124906"]])

export default __exports__